import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumnTemplate from "./AbstractPeriodColumnTemplate.js";
import OpeningBalanceColumn from "../../reports/columns/OpeningBalanceColumn.js";

/**
 * Opening balance column template.
 */
export default class OpeningBalanceColumnTemplate extends AbstractPeriodColumnTemplate {
	accept(visitor) {
		return visitor.visitOpeningBalanceColumnTemplate(this);
	}

	_instanceClass() {
		return OpeningBalanceColumn;
	}

	static getLabel() {
		return _("Opening balance");
	}

	static getType() {
		return "OpeningBalanceColumnTemplate";
	}
}
